export default {
  setNotification(state, params) {
    state.notificationState = params;
  },
  toggleNotification(state, bool) {
    state.notificationState.show = bool;
  }
};
